export const variants = {
  start: {
    initial: {
      x: '-100%'
    },
    animate: {
      x: '0%'
    }
  },
  end: {
    initial: {
      x: '100%'
    },
    animate: {
      x: '0%'
    }
  },
  top: {
    initial: {
      y: '-100%'
    },
    animate: {
      y: '0%'
    }
  },
  bottom: {
    initial: {
      y: '100%'
    },
    animate: {
      y: '0%'
    }
  }
};
